
import {Component, Prop, Vue} from 'vue-property-decorator';
import { RideitNotice } from '@/models/Rideit/RideitNotice';
import RideitNoticeForm from './RideitNoticeForm.vue';

@Component({
  components: {
    RideitNoticeForm,
  }
})
export default class RideitNoticeFormDialog extends Vue {
  formRef = 'noticeForm' as const;

  @Prop({ required: true }) private value: boolean;
  @Prop({ required: true }) private notice: RideitNotice;
  @Prop({ default: false }) private loading: boolean;

  get dialogVisible() {
    return this.value;
  }

  set dialogVisible(newValue: boolean) {
    this.$emit('input', newValue);
  }

  get cardTitle() {
    if (this.notice.id) {
      return this.$t('rideIt.communications_notice_edit');
    }
    return this.$t('rideIt.communications_notice_create_new');
  }

  saveNotice(notice: RideitNotice) {
    this.$emit('save', notice);
  }

  deleteNotice(notice: RideitNotice) {
    this.$emit('delete', notice);
  }

  cancel() {
    this.$emit('cancel');
  }

}
